const emptyOtherProps = {};
export default emptyOtherProps;
